import { useRefinementList } from 'react-instantsearch';

export function VirtualRefinementList(props: any) {
  useRefinementList(props);

  return null;
}
